import { z } from 'zod';
import {
  IconBoxMultiple,
  IconChartArea,
  IconChartBar,
  IconChartBubble,
  IconChartFunnel,
  IconChartHistogram,
  IconChartPie,
  IconChartSankey,
  IconCustomChartsLines,
  IconCustomChartsWaterfall,
  IconCustomTablePivot,
  IconFileAnalytics,
  IconGauge,
  IconList,
  IconMapPin,
  IconNumber123,
  IconProgress,
  IconTable,
  IconTimeline,
  IconTrendingUp,
  TablerIcon,
} from '@rossum/ui/icons/tabler';
import { absoluteApiUrl } from '../../../../constants/config';

// export const metabaseInstanceUrl = `https://${absoluteApiUrl}/svc/metabase`;

export const COLLECTION_MODEL = [
  'dashboard',
  'dataset',
  'no_models',
  'timeline',
  'snippet',
  'collection',
  'pulse',
  'metric',
  'card',
] as const;

export const COLLECTION_DISPLAY = [
  'area',
  'bar',
  'boxplot',
  'combo',
  'object',
  'funnel',
  'gauge',
  'line',
  'list',
  'map',
  'scalar',
  'pie',
  'pivot',
  'progress',
  'row',
  'sankey',
  'scatter',
  'table',
  'smartscalar',
  'waterfall',
] as const;

export type MetabaseDisplayType = (typeof COLLECTION_DISPLAY)[number];

export const COLLECTION_ICONS: Record<
  (typeof COLLECTION_DISPLAY)[number],
  TablerIcon | null
> = {
  area: IconChartArea,
  bar: IconChartBar,
  boxplot: IconBoxMultiple,
  combo: IconChartHistogram,
  object: IconFileAnalytics,
  funnel: IconChartFunnel,
  gauge: IconGauge,
  line: IconTimeline,
  list: IconList,
  map: IconMapPin,
  scalar: IconNumber123,
  pie: IconChartPie,
  pivot: IconCustomTablePivot,
  progress: IconProgress,
  row: IconCustomChartsLines,
  sankey: IconChartSankey,
  scatter: IconChartBubble,
  table: IconTable,
  smartscalar: IconTrendingUp,
  waterfall: IconCustomChartsWaterfall,
} as const;

export type ReportSummary = z.infer<typeof summarySchema>;

export const summarySchema = z.object({ summary: z.string() });

const apiDomain = new URL(absoluteApiUrl).hostname;

export const metabaseInstanceUrl = `https://${apiDomain}/svc/metabase`;

export type QueryType = 'sql' | 'mbql';
